var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.604 0A5.61 5.61 0 000 5.604c0 1.213.732 2.777 1.208 3.66l4.058 7.537a.386.386 0 00.676 0l4.059-7.537c.475-.882 1.208-2.447 1.208-3.66A5.61 5.61 0 005.604 0zm0 .773a4.825 4.825 0 014.831 4.831c0 .865-.67 2.472-1.11 3.291l-3.72 6.91-3.72-6.91C1.442 8.076.772 6.468.772 5.605A4.825 4.825 0 015.604.772zm0 1.932a2.904 2.904 0 00-2.899 2.9 2.904 2.904 0 002.9 2.898 2.904 2.904 0 002.898-2.899 2.904 2.904 0 00-2.899-2.899zm0 .773A2.12 2.12 0 017.73 5.604 2.12 2.12 0 015.604 7.73a2.12 2.12 0 01-2.126-2.126 2.12 2.12 0 012.126-2.126z",
    fill: "#000"
  })));
}
export default SvgLocation;